import { gql } from '@apollo/client';
import { DEVICE_FRAGMENT } from '@/entities/device/@x/patient-return';

const PATIENT_RETURNS_QUERY = gql`
  query patientReturns($filter: PatientReturnFilter, $limit: Int) {
    patientReturns(filter: $filter, limit: $limit) {
      id
      deviceId
      lastReturnLabel {
        transaction {
          trackingNumber
          trackingUrlProvider
        }
        trackingHistory {
          status
          statusDate
        }
      }
      studyStartDate
      studyEndDate
      study {
        id
        friendlyId
        timezone
        info {
          interprettingPhysician {
            id
          }
          patient {
            firstName
            lastName
          }
        }
        device {
          ...DeviceFragment
        }
      }
      facility {
        id
        name
      }
    }
  }

  ${DEVICE_FRAGMENT}
`;

export default PATIENT_RETURNS_QUERY;
